import styled, { css } from 'styled-components';
import { HEADER_VERSIONS } from 'src/components/ZillowNavbar/constants';
import { getBreakpointsForHeaderVersion } from 'src/components/ZillowNavbar/utils/getBreakpointsForHeaderVersion';

type ZillowNavbarLogoContainerProps = {
    version: HEADER_VERSIONS;
    isMobileNavOpen: boolean;
};

export const ZillowNavbarLogoContainer = styled.div<ZillowNavbarLogoContainerProps>`
    ${({ version, isMobileNavOpen }) => css`
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 16px;
        @media (max-width: ${getBreakpointsForHeaderVersion(version).MOBILE}px) {
            ${version === HEADER_VERSIONS.SEARCH_MOBILE_ONLY &&
            !isMobileNavOpen &&
            css`
                padding: 0;
                padding-right: 16px;
            `}
        }
        z-index: 2;
    `}
`;
